<template>
  <div>
    <div class="row">
      <div class="w-100 text-center mt-3">
        <h3>Parts Sold By Workshop</h3>
      </div>
      <div class="w-100 mt-3 mb-3 p-3 border-bottom border-danger">
        <div class="col-md-3 col-sm-4 d-md-inline-block">
          <span>Start Date:</span>
          <datepicker input-class="bg-dark text-white" :disabled-dates="{from: new Date()}" bootstrap-styling  v-model="fromDate" class="text-dark"></datepicker>
        </div>
        <div class="col-md-3 col-sm-4 d-md-inline-block">
          <span>End Date:</span>
          <datepicker input-class="bg-dark text-white" :disabled-dates="{from: new Date()}" bootstrap-styling  v-model="toDate" class="text-dark"></datepicker>
        </div>
        <div class="col-md-6 col-sm-4 d-md-inline-block mt-3">
          <button @click="fetchOrders" :class="!fromDate || !toDate ? 'btn-outline-danger disabled' : 'btn-success'" class="btn px-5">
            SEARCH <b-icon-search shift-h="10"></b-icon-search>
          </button>
        </div>
      </div>
    </div>
    <div class="w-100 position-relative" v-if="loading">
      <div class="w-100 mt-5 position-absolute text-center">
        <b-icon class="text-dark" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </div>
    <area-chart
      :colors="['#dc3545']"
      :dataset="{borderWidth: 4}"
      :messages="{empty: 'Select date range to generate stats'}"
      :data="chartData"></area-chart>

    <div v-if="Object.keys(data).length">
      <div class="row mt-3 overflow-hidden">
        <div class="col-12">
          <table class="table">
            <thead>
            <tr>
              <th scope="col">Date</th>
              <th scope="col">Quantity</th>
              <th class="d-none d-sm-table-cell" scope="col">Paid</th>
              <th class="d-none d-sm-table-cell" scope="col">Sold</th>
              <th class="d-none d-sm-table-cell" scope="col">Tax</th>
              <th scope="col">Earnings</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(val, key) of data" v-bind:key="key">
              <th scope="row">{{key}}</th>
              <td>{{val.count}}</td>
              <td class="d-none d-sm-table-cell">{{Math.round(val.totalNabavna).toLocaleString('en')}}kr</td>
              <td class="d-none d-sm-table-cell">{{Math.round(val.totalProdajna).toLocaleString('en')}}kr</td>
              <td class="d-none d-sm-table-cell">{{Math.round((val.totalProdajna - val.totalNabavna) * 0.25).toLocaleString('en')}}kr</td>
              <td>{{Math.round((val.totalProdajna - val.totalNabavna) - (val.totalProdajna - val.totalNabavna) * 0.25).toLocaleString('en')}}kr</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row overflow-hidden d-flex">
        <div class="col-md-3 col-sm-6 ml-auto">
          <table class="table font-weight-bolder float-right">
            <tr>
              <td class="text-right">TOTAL:</td>
              <td class="text-right">{{Math.round(this.prodajna).toLocaleString('en')}}kr</td>
            </tr>
            <tr>
              <td class="text-right">ENTRY PRICE:</td>
              <td class="text-right">{{Math.round(this.nabavna).toLocaleString('en')}}kr</td>
            </tr>
            <tr>
              <td class="text-right">TRANSPORT:</td>
              <td class="text-right">{{Math.round(this.nabavna * 0.30).toLocaleString('en')}}kr</td>
            </tr>
            <tr>
              <td class="text-right">TAX:</td>
              <td class="text-right">{{Math.round(this.prodajna * 0.25).toLocaleString('en')}}kr</td>
            </tr>
            <tr class="bg-success">
              <td class="text-right">EARNINGS:</td>
              <td class="text-right">{{Math.round((this.prodajna - this.nabavna) - (this.prodajna * 0.25) - (this.nabavna * 0.30)).toLocaleString('en')}}kr</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';

import fixed from '../../fixed';

export default {
  components: {
    Datepicker,
  },
  data: () => ({
    loading: false,
    data: {},
    fromDate: null,
    toDate: null,
    nabavna: 0,
    prodajna: 0,
  }),
  async mounted() {
    this.toDate = new Date();
    this.fromDate = new Date(this.toDate.getFullYear(), this.toDate.getMonth(), 1);
    await this.fetchOrders();
  },
  methods: {
    async fetchOrders() {
      if (!this.fromDate || !this.toDate) return;
      this.loading = true;
      try {
        const { data } = await axios.get(
          `${fixed.API_URL}/admin/orders?from=${moment(this.fromDate).format('yyyy-MM-DD')}&to=${moment(this.toDate).format('yyyy-MM-DD')}`,
          { withCredentials: true },
        );
        this.data = data.reduce((acc, current) => {
          const total = { prodajna: 0, nabavna: 0, count: 0 };
          current.articles.forEach((artikal) => {
            total.nabavna += artikal.nabavna * artikal.qtt;
            total.prodajna += artikal.prodajna * artikal.qtt;
            total.count += artikal.qtt;
          });

          const datumProdaje = moment(current.orderedAt).format('DD.MM.yyyy');

          if (!acc[datumProdaje]) {
            acc[datumProdaje] = {
              totalNabavna: total.nabavna,
              totalProdajna: total.prodajna,
              count: total.count,
            };
          } else {
            acc[datumProdaje].totalNabavna += total.nabavna;
            acc[datumProdaje].totalProdajna += total.prodajna;
            acc[datumProdaje].count += total.count;
          }

          return acc;
        }, {});
      } catch (error) {
        this.data = {};
        if (error.response && error.response.status === 403) {
          this.$toast.warning('you\'re not authorised for this action ✋🏻');
        } else {
          this.$toast.info('No data for selected range');
        }
      }
      this.loading = false;
    },
    resetTotal() {
      this.nabavna = 0;
      this.prodajna = 0;
    },
  },
  computed: {
    chartData() {
      this.resetTotal();
      const dataSet = {};
      Object.entries(this.data).forEach(([key, value]) => {
        this.nabavna += value.totalNabavna;
        this.prodajna += value.totalProdajna;
        dataSet[key] = value.count;
      });
      return dataSet;
    },
  },
};
</script>
